import { render } from "./BaseGlobalLoader.vue?vue&type=template&id=7917165c&scoped=true"
const script = {}

import "./BaseGlobalLoader.vue?vue&type=style&index=0&id=7917165c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7917165c"]])

export default __exports__